var mentions_default = {
  "mention": "NHQ5A",
  "mentionViewer": "V5Qex",
  "cursorDefault": "t-b8D",
  "cursorPointer": "f4hmA"
};
export {
  mentions_default as default
};
//# sourceMappingURL=mentions-scss.js.map
